import PageTitle from "UIPalette/PageTitle/PageTitle";
import { Error404 } from "../UIPalette/Error404/Error404";
import { useTranslation } from "react-i18next";

export const NotFound = () => {
  const { t } = useTranslation();

  return (
    <>
      <PageTitle title={t("pageTitle.notFound")} />
      <Error404 message={t("generalErrors.notFound")} />
    </>
  );
};
